import { jsx as _jsx } from "react/jsx-runtime";
import { Route, Routes } from "react-router-dom";
import { DynamicInvoicePage } from "./dynamic-invoice-page/dynamic-invoice-page";
export const DynamicInvoicePagesRoutes = () => (_jsx(Routes, { children: _jsx(Route, { path: "*", element: _jsx(DynamicInvoicePage, {}) }) }));
